import {
  AsphaltLotFilenameTemplateItem,
  AsphaltMaterialFilenameTemplateItem,
  AsphaltMixDesignFilenameTemplateItem,
} from '../classes/asphalt'
import { dateOptions } from '../utils'

export const AsphaltLotDate = new AsphaltLotFilenameTemplateItem({
  id: '1FF1C453-7651-46F2-B126-2E059DB2A8C0',
  name: 'Lot Date',
  property: 'testedDate',
  ...dateOptions({ name: 'Lot Date', tableNameSingular: 'Asphalt Lot' }),
})

export const AsphaltLotId = new AsphaltLotFilenameTemplateItem({
  id: '974CF293-4890-4DA2-929D-BC2C66767073',
  name: 'Lot ID',
  property: 'asphaltLotId',
  help: 'Asphalt Lot ID from Asphalt Lot table',
  exampleValue: 'PLA-0014',
})

export const AsphaltMixDesign = new AsphaltMixDesignFilenameTemplateItem({
  id: '40386F1F-A685-4DC3-8CBB-7F23EA51FF7F',
  name: 'Mix Design',
  property: 'mixDesignNumber',
  help: 'Mix Design Number from Asphalt Mix Design table',
  exampleValue: 'A141641C21',
})

export const AsphaltMixGrade = new AsphaltMixDesignFilenameTemplateItem({
  id: 'AD6A4A0C-DFDD-45BE-BBD4-C9CE3811AB4F',
  name: 'Mix Grade',
  property: 'grade',
  help: 'Grade from the Asphalt Mix Design table',
  exampleValue: 'PG 64-34',
})

export const AsphaltPlacementType = new AsphaltMaterialFilenameTemplateItem({
  id: '1065AE92-4D07-4ECE-B00C-56CF95EB23E3',
  name: 'Placement Type',
  property: 'placementType',
  help: 'Placement Type from Asphalt Materials table',
  exampleValue: 'HMA 700-900 Tons',
})

export const AsphaltShortName = new AsphaltMaterialFilenameTemplateItem({
  id: '399506FE-84E7-47D8-84E2-4DBA35B152DE',
  name: 'Placement Type Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Asphalt Materials table',
  exampleValue: 'HMA',
})

export type AsphaltFilename =
  | typeof AsphaltLotDate
  | typeof AsphaltLotId
  | typeof AsphaltMixDesign
  | typeof AsphaltMixGrade
  | typeof AsphaltPlacementType
  | typeof AsphaltShortName
